/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { Container } from 'react-bootstrap';
import { vappContainer } from '@/application';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { DigitalClock, Shelves, BrandHeader, Header } from '../components';

import { useTheme } from '@providers/theme';
import {
  useSMGetTime,
  useSMGetShelves,
  getShelvesMachine,
} from '@pages/VendingMachinePage/machines';
import { VendingMachinePageService } from '@pages/VendingMachinePage/services';
import { Loader } from '@/components';

const getSrv = () => {
  return vappContainer.get<VendingMachinePageService>(
    VendingMachinePageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const srv = getSrv();

  const { getTimeMachineState, getTimeMachineSend, getTimeMachine } =
    useSMGetTime({});
  const { getShelvesMachine, getShelvesMachineState, getShelvesMachineSend } =
    useSMGetShelves({});

  const triggerRefreshForGetTime = () => {
    setTimeout(() => {
      getTimeMachineSend('TRIGGER_REFRESH_FOR_GET_TIME', {});
    }, 30000);
  };

  const onHeaderRefresh = () => {
    getShelvesMachineSend('TRIGGER_REFRESH_FOR_GET_SHELVES', {});
  };

  const _onProductDispense = (product: any) => {
    console.log('product click ->', product);
  };

  const _renderDigitalClock = () => {
    if (getTimeMachineState?.matches('RENDER_TIME')) {
      triggerRefreshForGetTime();
      return (
        <DigitalClock {...(getTimeMachineState?.event?.data?.value || {})} />
      );
    }
  };

  const _renderShelves = () => {
    if (getShelvesMachineState?.matches('RENDER_SHELVES')) {
      return (
        <Shelves
          {...(getShelvesMachineState?.event?.data?.value || {})}
          onProductClick={_onProductDispense}
        />
      );
    }
    if (getShelvesMachineState?.matches('GET_SHELVES')) {
      return (
        <Loader
          {...(srv?.agent?.getLoadingContentSync()?.loading?.shelvesLoading ||
            {})}
        />
      );
    }
  };

  const _renderBrandHeader = () => {
    return (
      <BrandHeader
        {...(srv?.agent?.getStaticContentSync()?.brandHeader || {})}
      />
    );
  };

  const _renderHeader = () => {
    if (srv?.agent?.getStaticContentSync()?.header) {
      return (
        <Header
          {...(srv?.agent?.getStaticContentSync()?.header || {})}
          onRefreshClick={onHeaderRefresh}
        />
      );
    }
  };

  const _renderPage = () => {
    return (
      <>
        {_renderBrandHeader()}
        {_renderDigitalClock()}
        {_renderHeader()}
        {_renderShelves()}
      </>
    );
  };
  return (
    <>
      <Container>{_renderPage()}</Container>
    </>
  );
};
